<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="card_container" style="flex: 0 0 22%">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-12 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button active_tab"
                style="height: 80px; width: 80px"
              >
                <h3 class="text-white">{{ tableCount }}</h3>
              </div>
              <div class="text-center mt-3 bold-text primary-color">
                {{ $t("text.bAssets.title") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_order"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div
              class="row align-items-center d-flex justify-content-center section__row"
            >
              <div class="col-md-10">
                <div class="ml_5">
                  <h5 class="text-white">{{ $t("text.bAssets.bAssets") }}</h5>
                  <div class="mt-4">
                    <span class="text-white grey-para">{{
                      $t("text.bAssets.bAssets")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div
            class="col-md-12 col-lg-12 mt-3"
            v-show="branchAssets.length > 0 && !showLoader"
          >
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="false"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :allowTextWrap="true"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="80" field="index" headerText="#"></e-column>
                <e-column
                  width="150"
                  field="name"
                  :headerText="$t('text.form.name')"
                ></e-column>
                <e-column
                  width="180"
                  field="assetLicenseNo"
                  :headerText="$t('text.bAssets.licenseNo')"
                ></e-column>
                <e-column
                  width="180"
                  field="assetGroupName"
                  :headerText="$t('text.bAssets.assetGroup')"
                ></e-column>
                <e-column
                  width="140"
                  field="assetStatusFormatted"
                  :headerText="$t('text.form.status')"
                ></e-column>
                <e-column
                  width="400"
                  :template="buttonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <Paginator
              v-show="!showLoader"
              :total-pages="totalPages"
              :per-page="pageSize"
              :current-page="currentPage"
              @pagechanged="onPageChange"
              @getPageSize="getPageSize"
              :pageSize="pageSize"
            />
          </div>
          <div class="col-md-12 col-lg-12 mt-3">
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
      <section
        class="products_summary__wrapper pb-5 mt-3"
        v-if="branchAssets.length < 1 && !showLoader"
      >
        <div
          class="empty_tank_wrapper"
          style="
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column wrap;
          "
        >
          <div class="text-center" style="margin-top: 30px">
            <h6 style="color: rgb(161, 146, 146); font-size: 13px">
              {{ $t("text.bAssets.noAssets") }}
            </h6>
          </div>

          <div class="text-center pb-5" style="margin-top: 50px">
            <img src="@/assets/img/gold-ingots.svg" width="170" />
          </div>
          <div class="text-center mt-3 pb-4">
            <h6 class="primary-color cursor-pointer font-bold">
              {{ $t("text.bAssets.addAssets") }}
            </h6>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import Paginator from "@/components/Paginator.vue";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Parent Assets :: Epump Portal",
  name: "Zones",
  components: {
    MasterLayout,
    TableLoader,
    Paginator,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      backgroundUrl,
      cardBackgroundUrl,
      branchAssets: [],
      first: true,
      tableCount: 0,
      first: true,
      pageSize: "10",
      totalPages: 1,
      currentPage: 1,
      assetNumber: "",
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: [],
      search: { operator: "contains", ignoreCase: true },
      details: {
        queryStrings: { id: "" },
        itemData: {},
      },
    };
  },
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Assets:: ${branch.name} Retail Outlet`;
    });
  },

  mounted() {
    this.showLoader = true;
    // if (this.$route.query.branchId) {
    //     const company = localStorage.getItem("companyDetails")
    //     ? JSON.parse(localStorage.getItem("companyDetails"))
    //     : null
    //     if (company) {
    //         this.companyId = company.id
    //     }
    // } else {
    //     const branches = localStorage.getItem("totalBranches")
    //     ? JSON.parse(localStorage.getItem("totalBranches"))
    //     : null
    //     if (branches.length) {
    //         this.companyId = branches[0].companyId
    //     }
    // }

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.getGroups();
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getPageSize(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.tableCount / pageSize);
      this.getAssets();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getAssets();
    },
    getAssets() {
      this.first ? (this.showLoader = true) : (this.showLoader = false);
      this.first = false;
      const status = this.status == "allStatus" ? "" : parseInt(this.status);
      const group =
        this.groupId == "selectAGroup" || this.groupId == "allGroups"
          ? ""
          : this.groupId;

      const fromDate = this.fromDate == null ? "" : this.fromDate;
      const toDate = this.toDate == null ? "" : this.toDate;
      const isActive =
        this.isActive == "selectActive" || this.isActive == ""
          ? ""
          : this.isActive == "true"
          ? true
          : false;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Assets?PageIndex=${
            this.currentPage
          }&PageSize=${this.pageSize}&Sort=${
            this.sortColumn
          }&isActive=${isActive}&ApplyPaging=${true}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.totalPages = Math.ceil(response.data.count / this.pageSize);
          this.tableCount = response.data.count;
          let index = 0 + (this.currentPage - 1) * this.pageSize;
          response.data.data.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          response.data.data.forEach((cur, ind) => {
            cur.index = ++index;
            cur.ind = ind + 1;
            cur.isActiveFormatted = cur.isActive ? "Yes" : "No";
            cur.assetLicenseNo = cur.assetLicenseNo
              ? cur.assetLicenseNo
              : "N/A";
            cur.assetStatusFormatted =
              cur.assetStatus == 0
                ? "Okay"
                : cur.assetStatus == 1
                ? "Service Due"
                : cur.assetStatus == 2
                ? "Renewal Due"
                : cur.assetStatus == 4
                ? "Not Active"
                : "Renewed";
          });

          this.branchAssets = response.data.data;
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
  },
};
</script>

<style></style>
